<template>
  <div class="table-container">
    <div class="table-header">
      <h3>Lender Score</h3>
    </div>

    <TableRow
      v-for="item in scores"
      :key="item.category"
      :data="item" />
  </div>
</template>

<script>
import TableRow from './TableRow'

export default {
  name: 'LenderScoreTable',
  components: {
    TableRow,
  },
  props: {
    lender: Object,
  },
  computed: {
    scores () {
      if (!this.lender) return []

      const {
        scoreGathering,
        scoreTimeliness,
        scoreResponsiveness,
        scoreClarity,
        scoreOverall,
        topRatedFields,
      } = this.lender

      return [
        {
          category: 'Data Gathering Process',
          score: scoreGathering,
          topRated: !!(topRatedFields && topRatedFields.scoreGathering),
        },
        {
          category: 'Timeliness',
          score: scoreTimeliness,
          topRated: !!(topRatedFields && topRatedFields.scoreTimeliness),
        },
        {
          category: 'Responsiveness',
          score: scoreResponsiveness,
          topRated: !!(topRatedFields && topRatedFields.scoreResponsiveness),
        },
        {
          category: 'Clarity of Process',
          score: scoreClarity,
          topRated: !!(topRatedFields && topRatedFields.scoreClarity),
        },
        {
          category: 'Overall Experience',
          score: scoreOverall,
          topRated: !!(topRatedFields && topRatedFields.scoreOverall),
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.table-container {
  height: auto;
  width: 100%;

  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: auto repeat(5, 1fr);

  & > div {
    &:nth-child(even) { background-color: white; }
    &:nth-child(odd) { background-color: $tertiaryBlue; }
  }

  .table-header {
    height: 65px;

    display: flex;
    justify-content: center;
    align-items: center;

    background-color: $primaryBlue !important;
    color: white;
  }

  @include lg {
    height: 730px;
    width: 240px;

    border: 2px solid $primaryBlue;
  }
}
</style>
